export default __webpack_public_path__ + "static/media/ReactNative.0492c1b1.png";